import secondaryComponents from "../../secondaryComponents";
import styles from "./styles.module.scss";
import primaryComponents from "../../primaryComponents";
import { AngleLeft, CloseIcon } from "../../../assets/svgIcons";
import { useNavigate } from "react-router-dom";

export const RoutedModal = ({
  children,
  showHeader = true,
  headerTitle = "",
  headerDescription = "",
  hasPrevNavigation = false,
  routeToPrev = null,
  closeModal = () => {},
  leftHeaderSide = (
    <div>
      <h4 className="mb-0">{headerTitle}</h4>
      <p>{headerDescription}</p>
    </div>
  ),
  rightHeaderSide = (
    <primaryComponents.Button
      style={{ padding: "0 10px", flexShrink: 0, height: "45px" }}
      classNames={"btn btn--outline"}
      onClick={closeModal}
    >
      <CloseIcon className="dark--text mr-1" style={{ fontSize: "20px" }} />
      Close
    </primaryComponents.Button>
  ),
  usePadding = true,
  style = {},
  bodyStyle = {},
  width = 1300,
  ...rest
}) => {
  const navigate = useNavigate();

  return (
    <secondaryComponents.Modal
      closeModal={closeModal}
      width={width}
      padding={0}
      style={{
        maxHeight: "100%",
        height: "100vh",
        borderRadius: "0",
        ...style,
      }}
      {...rest}
    >
      {showHeader ? (
        <div className={styles.routedModal__header}>
          <div className="d-flex alin-items-center" style={{ gap: "10px" }}>
            {hasPrevNavigation ? (
              <primaryComponents.Button
                classNames={"btn btn--outline"}
                onClick={() => {
                  if (routeToPrev) return routeToPrev();
                  navigate(-1);
                }}
                style={{ width: "45px" }}
              >
                <AngleLeft
                  className="dark--text"
                  style={{ fontSize: "20px" }}
                />
              </primaryComponents.Button>
            ) : null}
            {leftHeaderSide}
          </div>
          {rightHeaderSide}
        </div>
      ) : null}
      <div
        className={`${styles.routedModal__body} ${usePadding ? styles.padding : ""}`}
        style={{ ...bodyStyle }}
      >
        {children}
      </div>
    </secondaryComponents.Modal>
  );
};
